import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel } from '@mui/material';
import CheckBoxOutlineBlankSharpIcon from '@mui/icons-material/CheckBoxOutlineBlankSharp';
import CheckBoxSharpIcon from '@mui/icons-material/CheckBoxSharp';


const CalendarHeaderHoliday = ({checked, onHandleCheckOfHoliday}) => {
    const { t } = useTranslation();

    return (
        <FormControlLabel
            control={
                <Checkbox
                    checked={checked}
                    checkedIcon={<CheckBoxSharpIcon className="check-box-con-solid" />} 
                    className="styledCheckBox"
                    disableRipple
                    icon={<CheckBoxOutlineBlankSharpIcon className="check-box-icon-outline" />}
                    name="standard-checkbox"
                    onChange={onHandleCheckOfHoliday}
                />
            }
            label={t('myBlockMonth.stripCalendarHeader.includeHolidays')}
        />
        
    )
}

export default CalendarHeaderHoliday;